module.exports = __webpack_public_path__ + "static/media/selfie_headshot.10481df0.JPG";